// Copyright (c) 2017 Deere & Company

import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import t from 'tcomb';

const Report = t.list(PipHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/pip-history/state/report.js